'use strict';

const photoSize = {
  default: {
    small: {
      w: 380,
      h: 240,
      cropRatio: 95/60,
      defaultPhoto: require('../../images/cities/barcelona_default@2x.jpg'),
    },
    large: {
      w: 1400,
      h: 560,
      dpr: 1,
      defaultPhoto: require('../../images/intro/header_barcelona.jpg'),
    }
  },
  landing_default: {
    small: {
      w: 380,
      h: 240,
      cropRatio: 95/60,
      defaultPhoto: 'https://showaroundoriginal.imgix.net/places/ChIJD7fiBh9u5kcRYJSMaMOCCwQknitr.jpg?w=380&dpr=1.5&or=0&bri=0&con=0&q=0'
    },
    large: {
      w: 1400,
      h: 560,
      dpr: 1,
      defaultPhoto: 'https://showaroundoriginal.imgix.net/places/ChIJD7fiBh9u5kcRYJSMaMOCCwQknitr.jpg?w=1400&dpr=1&or=0&bri=0&con=0&q=0'
    }
  }
};

export default function cityPhoto(imgixHelpers) {
  'ngInject';

  return function (photo, size, allowDefault = true, landing = false) {
    var sizeInfo = photoSize.default[size] || photoSize.default.small;
    if (landing) {
      sizeInfo = photoSize.landing_default[size] || photoSize.landing_default.small;
    }

    let url;

    if (photo) {
      url = imgixHelpers.getUrl(photo, sizeInfo, getCropCoords(photo, sizeInfo));
    } else if (allowDefault) {
      url = sizeInfo.defaultPhoto;
    } else {
      url = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }

    return url;
  };
}

function getCropCoords (photo, sizeInfo) {
  var coords = null;
  var width;

  if (sizeInfo.cropRatio) {
    width = Math.ceil(photo.height * sizeInfo.cropRatio);
    coords = String(Math.ceil((photo.width - width) / 2)) + ',0,' + String(width) + ',' + photo.height;
  }

  return coords;
}



// WEBPACK FOOTER //
// ./app/src/filters/city_photo.js